<template>
  <div name="online-form" class="query-sql-content" :style="conheight">
      <!-- <h3 class="flow_table_title query-sql__title">{{`${queryView.name? `${queryView.name}列表`:""}`}}</h3> -->
    <span v-if="html">
      <dynamic-view :sqlAlias="sqlAlias" :alias="alias" :html="html" :single="single" :queryView="queryView"/>
    </span>
    <div class="loaded-fail__div" v-if="loadedFail">{{alias}}视图不存在...</div>
  </div>
</template>

<script>
  import DynamicView from "@/components/querySql/DynamicView.vue";
  import utils from "@/utils.js";

  export default {
    name: "querySqlContent",
    props: {
      sqlAlias: String,
      alias: String,
      single: String,
    },
    data() {
      return {
        queryView: {},
        displayFields: [],
        html: "",
        alarmSettingMap:{},
        summaryTypeMap:{},
        loadedFail:false,
        conheight: { height: "" }
      };
    },
    watch: {
      alias: function(newVal) {
        if (newVal) {
          this.init();
        }
      }
  },
    components: {
      DynamicView
    },

    created() {
      this.init();
      window.addEventListener("resize", this.getHeight);
    this.getHeight();
    },
    methods: {
      getHeight() {
      this.conheight.height = window.innerHeight - 100 + "px";
    },
      // 根据当前formKey初始化
      init() {
        const loading = this.$loading(this.options);
        let _me = this;
        this.$store
                .dispatch("form/getQuerySqlView", {
                  sqlAlias: this.sqlAlias,
                  alias: this.alias
                })
                .then(result => {
                  if (result) {
                    _me.queryView = result;
                    _me.html = result.template;

                    let params = { sqlAlias: _me.sqlAlias, alias: _me.alias };
                    let pageBean = {
                      pageBean: {
                        page: "1",
                        pageSize:result.pageSize ? result.pageSize : 10,
                        showTotal: "true"
                      }
                    }; //初次加载默认pageBean
                    params.pagination = pageBean;
                    this.$store
                            .dispatch("form/getQuerySqlViewByPagination", params)
                            .then(() => {
                              loading.close();
                            });
                  }else{
                    this.loadedFail = true;
                  }
                }).finally(()=>{
                  loading.close();
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
  /deep/ th.todo-header-row {
    background-color: #fafafa;
    font-size: 12px;
  }
  /deep/.el-collapse-item__content{
    margin-left: 0px;
    .el-row{
      min-width: 10%;
    }
  }
  /deep/ tr.todo-row {
    font-size: 12px;
    color: $--color-text-regular;
  }
  .query-sql__title{
    background: #fff;
    padding-top: 17px;
    margin-top: 0;
  }
  .el-container {
    background-color: #fff;
  }

  .el-row {
    margin-bottom: 20px;
  }

  .el-header {
    border-bottom: 1.5px solid #ededed;
  }

  .i {
    margin-right: 4px;
  }

  .todo-subject {
    cursor: pointer;
  }

  .todo-subject:hover {
    color: $--theme-color;
  }

  /deep/ .el-dialog__body {
    padding: 15px 10px;
  }

  /deep/ .el-checkbox {
    margin-left: 15px;
  }

  /deep/ .el-radio {
    margin-left: 15px;
  }

  /deep/ .el-button {
    margin-right: 16px;
    margin-bottom: 0px;
  }
  .loaded-fail__div {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #f56c6c;
  }
  /deep/ .el-footer{
  justify-content: flex-start;
  padding: 16px 0px !important;
}
.query-sql-content{
  height: 100%;
  /deep/.el-container{
    height: calc(100% - 49px);
  }
}
/deep/ .el-form-item--small.el-form-item{
  padding-right: 0px;
  margin-right: 16px;
}
</style>
